import { BaseOrganizationEndpoints } from "./base";

export interface BillingPortalResponse {
  url: string;
}

export class Billing extends BaseOrganizationEndpoints {
  async getPortalUrl() {
    return this.requestWithStatus<BillingPortalResponse>(
      "GET",
      "/v1/billing/portal"
    );
  }
}
